var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"route-tree"}},[_c('div',{attrs:{"id":"tree"}},[_c('div',{staticClass:"entry"},[_vm._m(0),_c('node',{attrs:{"item":_vm.root}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-3v3"},[_c('strong',[_vm._v("CIR")])])
}]

export { render, staticRenderFns }